export enum PlatformAccessStatus {
  Active = "active",
  PaymentPastDue = "payment-past-due",
  PaymentDelinquent = "payment-delinquent",
  Deactivated = "deactivated",
}

export const extractPlatformStatus = (
  platform?: {
    accessStatus: string;
  } | null
): PlatformAccessStatus => {
  switch (platform?.accessStatus) {
    case "Deactivated":
      return PlatformAccessStatus.Deactivated;
    case "PaymentPastDue":
      return PlatformAccessStatus.PaymentPastDue;
    case "PaymentDelinquent":
      return PlatformAccessStatus.PaymentDelinquent;
    case "Active":
    default:
      return PlatformAccessStatus.Active;
  }
};
